module.exports = __webpack_public_path__ + "static/img/img-2.21d367c4.png";